import React from 'react'
import { View } from 'styles/reactnative'
import AdminPopUpTable from './AdminPopUpTable'
import PopUpCreate from './PopUpCreate'
import AdminSettingHeader from '../AdminSettingHeader'
import { usePopUp } from 'app/hooks/AdminSettings/popUp'

const AdminPopupSetting = ({ title, type }: any) => {
	const { searchApi, search: searchText } = usePopUp()
	return (
		<View style={{ width: '100%' }}>
			<AdminSettingHeader
				title={'팝업설정'}
				searchApi={searchApi}
				searchText={searchText}
				CustomComp={<PopUpCreate />}
			/>
			<AdminPopUpTable />
		</View>
	)
}

export default React.memo(AdminPopupSetting)
